export const ROUTES = {
  HOME: '/',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  LOGIN: '/login',
  MFA: '/mfa',
  FORGOT_PASSWORD: '/forgot-password',
  ONBOARDING: '/onboarding',
  ONBOARDING_COMPLETE: '/onboarding/complete',

  FIRST_LOGIN_CHANGE_PASSWORD: '/change-password',

  DASHBOARD: '/dashboard',
  GUIDE: '/dashboard/guide',
  SUPPORT: '/dashboard/support',
  CHANGE_PASSWORD: '/dashboard/change-password',

  // Policy Administration
  POLICIES: '/dashboard/policies',
  POLICY_NEW: '/dashboard/policies/new',
  POLICY_DETAIL: '/dashboard/policies/:id',
  POLICY_RENEWALS: '/dashboard/policies/renewals',
  POLICY_ENDORSE: '/dashboard/policies/:id/endorse',

  // Claims
  CLAIMS: '/dashboard/claims',
  CLAIM_NEW: '/dashboard/claims/new',
  CLAIM_DETAIL: '/dashboard/claims/:id',
  RECOURSE_LIST: '/dashboard/claims/recourse',
  RECOURSE_DETAIL: '/dashboard/claims/recourse/:id',
  LITIGATION_LIST: '/dashboard/claims/litigation',
  LITIGATION_DETAIL: '/dashboard/claims/litigation/:id',
  APP_CHANNEL_CLAIM_DETAIL: '/dashboard/claims/app-channel/:id',

  // Clients & Agents
  CLIENTS: '/dashboard/clients',
  CLIENT_NEW: '/dashboard/clients/new',
  CLIENT_DETAIL: '/dashboard/clients/:id',
  AGENTS: '/dashboard/agents',
  AGENT_NEW: '/dashboard/agents/new',
  AGENT_DETAIL: '/dashboard/agents/:id',

  // Billing & Finance
  BILLING: '/dashboard/billing',
  BILLING_PREMIUMS: '/dashboard/billing/premiums',
  BILLING_COMMISSIONS: '/dashboard/billing/commissions',
  BILLING_REINSURANCE: '/dashboard/billing/reinsurance',
  BILLING_TAX: '/dashboard/billing/tax',
  BILLING_LEDGER: '/dashboard/billing/ledger',
  BILLING_FINANCE: '/dashboard/billing/finance',
  BILLING_FINANCE_PREMIUMS: '/dashboard/billing/finance/premiums',
  BILLING_FINANCE_LEDGER: '/dashboard/billing/finance/ledger',
  BILLING_FINANCE_OVERDUE: '/dashboard/billing/finance/overdue',
  BILLING_RESERVES: '/dashboard/billing/reserves',
  BILLING_SOLVENCY: '/dashboard/billing/solvency',
  BILLING_PERIODS: '/dashboard/billing/periods',
  BILLING_REMITTANCES: '/dashboard/billing/remittances',
  BILLING_REVENUE_ACCOUNT: '/dashboard/billing/revenue-account',

  // Analytics
  ANALYTICS: '/dashboard/analytics',
  ANALYTICS_UNDERWRITING: '/dashboard/analytics/underwriting',
  ANALYTICS_CLAIMS: '/dashboard/analytics/claims',
  ANALYTICS_FINANCIAL: '/dashboard/analytics/financial',
  ANALYTICS_AGENTS: '/dashboard/analytics/agents',
  ANALYTICS_STP: '/dashboard/analytics/stp',
  ANALYTICS_CAPITAL_ADEQUACY: '/dashboard/analytics/capital-adequacy',
  ANALYTICS_CAPITAL_ADEQUACY_INPUT: '/dashboard/analytics/capital-adequacy/data-inputs',

  // HR
  HR: '/dashboard/hr',
  HR_EMPLOYEES: '/dashboard/hr/employees',
  HR_EMPLOYEE_NEW: '/dashboard/hr/employees/new',
  HR_EMPLOYEE: '/dashboard/hr/employees/:id',
  HR_LEAVE: '/dashboard/hr/leave',
  HR_ORG_CHART: '/dashboard/hr/org-chart',

  // Products
  PRODUCTS: '/dashboard/products',
  PRODUCT_NEW: '/dashboard/products/new',
  PRODUCT_DETAIL: '/dashboard/products/:id',
  PRODUCT_EDIT: '/dashboard/products/:id/edit',

  // STP
  STP_RULES: '/dashboard/stp/rules',
  STP_ANALYTICS: '/dashboard/stp/analytics',

  // Settings
  SETTINGS_PROFILE: '/dashboard/settings/profile',
  SETTINGS_GENERAL: '/dashboard/settings/general',
  SETTINGS_USERS: '/dashboard/settings/users',
  SETTINGS_ROLES: '/dashboard/settings/roles',
  SETTINGS_BRANDING: '/dashboard/settings/branding',
  SETTINGS_MFA: '/dashboard/settings/mfa',
  SETTINGS_WEBHOOKS: '/dashboard/settings/webhooks',
  SETTINGS_API_KEYS: '/dashboard/settings/api-keys',
  SETTINGS_MIGRATION: '/dashboard/settings/migration',
  SETTINGS_AUDIT_LOG: '/dashboard/settings/audit-log',
  SETTINGS_FRAUD_RULES: '/dashboard/settings/fraud-rules',
  SETTINGS_BLACKLIST: '/dashboard/settings/blacklist',
  SETTINGS_COMPANY_PROFILE: '/dashboard/settings/company-profile',
  SETTINGS_TAX: '/dashboard/settings/tax',
  SETTINGS_CERTIFICATES: '/dashboard/settings/certificates',
  SETTINGS_WORDING: '/dashboard/settings/wording',
  SETTINGS_BILLING: '/dashboard/settings/billing',

  // Fast Inspections
  INSPECTIONS: '/dashboard/inspections',
  INSPECTION_DETAIL: '/dashboard/inspections/:id',

  // AI Insurance Intelligence
  COPILOT: '/dashboard/copilot',

  // Subscription
  SUBSCRIPTION: '/dashboard/subscription',
  UPGRADE: '/subscription/upgrade',
  SUBSCRIPTION_LOCKED: '/subscription/locked',
  SUBSCRIPTION_CONFIRM: '/subscription/confirm',
  PAYMENT_SUCCESS: '/subscription/payment-success',

  // Broker Portal
  BROKER_DASHBOARD: '/broker',
  BROKER_POLICIES: '/broker/policies',
  BROKER_POLICY_DETAIL: '/broker/policies/:id',
  BROKER_COMMISSIONS: '/broker/commissions',
  BROKER_DOCUMENTS: '/broker/documents',
  BROKER_MESSAGES: '/broker/messages',
  BROKER_NEW_MESSAGE: '/broker/messages/new',
  BROKER_MESSAGE_DETAIL: '/broker/messages/:id',

  // Platform (super-admin)
  PLATFORM: '/platform',
  PLATFORM_CLIENTS: '/platform/clients',
  PLATFORM_CLIENT_NEW: '/platform/clients/new',
  PLATFORM_CLIENT_DETAIL: '/platform/clients/:id',
  PLATFORM_CLIENT_EDIT: '/platform/clients/:id/edit',
  PLATFORM_SUBSCRIPTIONS: '/platform/subscriptions',
  PLATFORM_TRIALS: '/platform/trials',
  PLATFORM_BILLING: '/platform/billing',
  PLATFORM_INVOICES: '/platform/invoices',
  PLATFORM_REVENUE: '/platform/revenue',
  PLATFORM_MODULES: '/platform/modules',
  PLATFORM_AUDIT: '/platform/audit',
  PLATFORM_ACTIVITY: '/platform/activity',
  PLATFORM_SETTINGS: '/platform/settings',
} as const;
